import cookie from 'cookie_js';

/**
 * @function isUserLoggedIn
 * @memberof Promega.Util
 * @description Determines whether or not the user is currently logged in.
 * @returns {Boolean} True if the user is logged into a Promega.com account; otherwise, false.
*/
export default function isUserLoggedIn() {
    return parseInt(cookie.get("UserLoginStatus"), 10) === 1 ? true : false;
}
